export enum TeamName {
  tools = 'Tools',
  risk = 'Risk',
  cx = 'cx',
  pops = 'pops'
}
